import BillingInformationContainer from './billing-information-container';

export default BillingInformationContainer;
